import { render, staticRenderFns } from "./TypeFilePPXIcon.vue?vue&type=template&id=1657acf6&"
import script from "./TypeFilePPXIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFilePPXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports